var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flag)?_c('div',{staticClass:"isFlag"},[_c('span'),_c('p',[_vm._v(_vm._s(_vm.flag?_vm.title[0]:_vm.title[1]))])]):_c('div',{staticClass:"noFlag"},[_c('span'),_c('p',[_vm._v(_vm._s(_vm.flag?_vm.title[0]:_vm.title[1]))])])])}
var staticRenderFns = []

export { render, staticRenderFns }